module.exports = __webpack_public_path__ + "static/03-handoff@2x-c9fee0a716cabe557c96bb96ae73eeb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/homepage/03-handoff@2x.jpg
// module id = 2642
// module chunks = 35783957827783